import React, { useEffect, useState } from 'react'
import { queryUserImage } from 'services/requests';
import { CancelToken, isCancel } from 'axios'
import PropTypes from 'prop-types'
import { Avatar } from 'components/atoms'
import { Tooltip } from 'components/molecules'
import { useMountedState } from 'react-use';

const UserAvatar = ({
  userId,
  name,
  className,
  ...props
}) => {
  const [userAvatar, setUserAvatar] = useState(null)
  const [loadingUserAvatar, setLoadingUserAvatar] = useState(false)
  const isMounted = useMountedState();

  useEffect(() => {
    const sourceUser = CancelToken.source();
    const sourceAvatar = CancelToken.source();
    // eslint-disable-next-line no-unused-vars
    async function fetchUserAvatar() {
      setLoadingUserAvatar(true)
      try {
        const imageData = await queryUserImage(userId, { cancelToken: sourceAvatar.token })
        const hasImage = imageData && imageData.data && imageData.data.byteLength > 0
        const image = hasImage ? `data:image/jpeg;base64,${Buffer.from(imageData.data, 'binary').toString('base64')}` : null
        setUserAvatar(image)
        setLoadingUserAvatar(false)
      } catch (err) {
        const cancelled = isCancel(err)
        if (!cancelled && isMounted) {
          // error wasn't due to cancelling
          setLoadingUserAvatar(false)
          setUserAvatar(null)
        }
      }
    }

    // todo re-do this
    // fetchUserAvatar()

    // cleanup function that cancels pending requests
    return () => {
      sourceUser.cancel()
      sourceAvatar.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  if (name) {
    return (
      <Tooltip tooltip={name} placement="top">
        <Avatar
          image={userAvatar}
          className={className}
          {...props}
        />
      </Tooltip>
    )
  }

  return (
    <Avatar
      image={userAvatar}
      className={className}
      loading={loadingUserAvatar}
      {...props}
    />
  )
}

UserAvatar.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
}

UserAvatar.defaultProps = {
  name: null,
  className: '',
}

export default UserAvatar
